<script>

import Swal from "sweetalert2";
import moment from "moment/moment";
import api from "@/axios";
import {getBaseUrl} from "@/helpers/baseUrl";


export default {
  setup() {
    return { };
  },
  components: {

  },
  props: {
    orctoList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    updating: {
      type: Boolean,
    },
  },
  data() {
    return {
      valorTotalItens: 0,
      titleModalItensPed: 'Resumo de Orçamento',
      clienteData: null,
      orctoData: null,
      orctoItensData: null,
      loadingOrctoDetail: false,
      showModalItensPed: false,
      regSelecionado: {},

    };
  },
  mounted() {
    // console.log('mounted orcamentos-table_0')
    // console.log(this.updating)
  },
  methods: {
    nomeStatus(strEntr){
      let result = 'Não Definido'
      switch (strEntr) {
        case 'FA':
          result = 'Faturado'
          break
        case 'EL':
          result = 'Elaboração'
          break
        case 'CP':
          result = 'Conf. Parcial (CP)'
          break
        case 'CA':
          result = 'Cancelado'
          break
        case 'CO':
          result = 'Confirmado'
          break
        default:
          result = 'Não Definido'
          break
      }
      return result
    },

    detalhes(idData){
      console.log('detalhes_0: ' + idData)
      this.loadingOrctoDetail = true
      this.showModalItensPed = true
      this.valorTotalItens = 0

      api.get(`${getBaseUrl()}api/orcamento`, {
        params: { iddata: idData }
      }).then((res) => {
        console.log('then axios_detalhe')
        this.orctoData = res.data[0]
        this.clienteData = res.data[1]
        this.orctoItensData = res.data[5]

        // console.log(res.data)

        if (this.orctoItensData.length > 0){
          this.orctoItensData.forEach((value) => {
            if (value.imgs){
              let imgTrat = value.imgs.split(',')
              value.img1 = `${getBaseUrl() + '_IMG'}/peq/${imgTrat[0]}`
            }

            // console.log(value.vlrtotalliq);
            let valor = parseFloat(value.vlrtotalliq)
            this.valorTotalItens += valor
          });
        }

        console.log('this.orctoItensData')
        console.log(this.orctoItensData)


        this.titleModalItensPed = `Resumo de Orçamento (${ this.orctoData.id })`
        this.loadingOrctoDetail = false
      });

    },

    editar(idData){
      console.log('editar: ' + idData)
      this.$router.push(`/orcamento/editar/${idData}`)
    },

    deletar(idData){
      console.log('deletar_0: ' + idData)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.$emit('deletareg', idData)
        }
      })
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

  },
};
</script>

<template>
  <div class="table-responsive mb-0">

    <table class="table align-middle table-nowrap">
      <thead class="table-light">
      <tr>
        <th class="align-middle">ID</th>
        <th class="align-middle">Sigla</th>
        <th class="align-middle">Nome</th>
        <th class="align-middle">Email / Telefone</th>
        <th class="align-middle">Status</th>
        <th class="align-middle">Cidade</th>
        <th class="align-middle">Condição</th>
        <th class="align-middle">Forma</th>
        <th class="align-middle">Temperatura</th>
        <th class="align-middle">Criado</th>
        <th class="align-middle">Atualizado</th>
        <th class="align-middle text-end">Peso</th>
        <th class="align-middle text-end">Valor</th>
        <th class="align-middle">Ações</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="data in orctoList" :key="data.id">

        <td>
          <a href="javascript: void(0);" class="text-body fw-bold" @click="editar(data.id)">
            #{{ data.id }}
          </a>
        </td>

        <td>
          <div v-if="!data.image" class="avatar-xs">
            <span class="avatar-title rounded-circle">{{ data.cliente.substring(0, 3) }}</span>
          </div>
        </td>

        <td>{{ data.nome }} </td>

        <td>{{ data.email }} <br> {{ data.tel1 }}  </td>

        <td>
              <span class="badge badge-pill badge-soft-success font-size-11"
                    :class="data.status === 'FA' ? 'badge-soft-success' :
                    data.status === 'EL' ? 'badge-soft-warning' : data.status === 'CO' ? 'badge-soft-info' : 'badge-soft-danger'"
              >
                {{ nomeStatus(data.status)  }}
              </span>
        </td>

        <td> {{ data.cidade }}</td>

        <td> {{ data.condpgto }}</td>

        <td>
          <i class="fab fab fa-cc-mastercard me-1" v-if="data.formapgto === '10'"></i>
          <i class="fab fab fa-cc-visa me-1" v-if="data.formapgto === '11'"></i>
          <i class="fab fab fa-paypal me-1" v-if="data.formapgto === '12'"></i>
          {{ data.formapgto }}
        </td>

        <td>
            <span class="badge bg-success font-size-12">
              <i class="mdi mdi-star me-1"></i>
              {{ data.id }}
            </span>
        </td>

        <td>{{ formatDateTime(data.created_at) }} </td>
        <td>{{ formatDateTime(data.created_at) }} </td>
        <td class="text-end">{{ formatDecimal(data.peso) }} </td>
        <td class="text-end">{{ formatDecimal(data.valorliq) }} </td>

        <td>
          <div class="button-items">

            <b-button variant="outline-success" @click="detalhes(data.id)">
              <i class="mdi mdi-eye d-block font-size-16"></i>
            </b-button>

            <b-button variant="outline-warning" @click="editar(data.id)" :disabled="data.email === 'admin@admin.com.br'">
              <i class="mdi mdi-pencil d-block font-size-16"></i>
            </b-button>

          </div>
        </td>


      </tr>
      </tbody>
    </table>


    <b-modal :title="titleModalItensPed" v-model="showModalItensPed" centered hide-footer>

      <div class="row" v-if="loadingOrctoDetail">
        <div class="col-12 text-center">
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
        </div>
      </div>

      <div v-if="!loadingOrctoDetail && orctoData && clienteData">

        <p class="mb-2">
          Código:
          <router-link :to="`/orcamento/editar/${orctoData.id}`" target="_blank">
            <span class="text-primary">{{ orctoData.id }}</span>
          </router-link>
        </p>
        <p class="mb-4">
          <router-link :to="`/cliente/detalhe/${clienteData.id}`" target="_blank">
            Cliente:
            <span class="text-primary">{{ orctoData.cliente }} - {{ clienteData.nome }}</span>
          </router-link>
        </p>
        <div class="table-responsive">
          <table class="table table-centered table-nowrap">
            <thead>
            <tr>
              <th scope="col">Produto</th>
              <th scope="col">Descrição</th>
              <th scope="col" class="text-end">Valor (R$)</th>
            </tr>
            </thead>
            <tbody>

            <tr v-for="data in orctoItensData" :key="data.id">
              <th scope="row">
                <h5 class="text-muted mb-0">{{ data.produto.substr(7, 15) }} </h5>
                <div>
                  <img v-if="data.img1"
                       :src="data.img1"
                       alt
                       class="avatar-sm"/>
                  <span
                      v-else
                      class="avatar-title rounded-circle" style="min-height: 50px;">{{ data.produto.substring(0, 3) }}</span>
                </div>

              </th>
              <td>
                <div>

                  <h5 class="text-truncate font-size-14 mb-0">
                    {{ data.descprod.substring(0, 28) }}
                  </h5>
                  <p class="text-muted mb-0">R$ {{ formatDecimal(data.vlrunitliq) }} x {{ formatInteger(data.qtd) }}</p>
                </div>
              </td>
              <td class="text-end">{{ formatDecimal(data.vlrtotalliq) }}</td>
            </tr>

            <tr>
              <td colspan="2">
                <h6 class="m-0 text-end">Sub Total:</h6>
              </td>
              <td class="text-end">R$ {{ formatDecimal(valorTotalItens) }}</td>
            </tr>

            <tr>
              <td colspan="2">
                <h6 class="m-0 text-end">Frete:</h6>
              </td>
              <td class="text-end">Grátis</td>
            </tr>

            <tr>
              <td colspan="2">
                <h6 class="m-0 font-size-14  text-end">Total:</h6>
              </td>
              <td class="font-size-14 text-end">R$ {{ formatDecimal(valorTotalItens) }}</td>
            </tr>

            </tbody>
          </table>
        </div>
      </div>
    </b-modal>


  </div>

</template>
